import { ControlContainer } from "@angular/forms";

export function ControlContainerFactory(controlContainer?: ControlContainer) {
  return controlContainer;
}
